import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'
import {
  configState,
  pageState,
  resultsState,
  searchState
} from '../state/page'
import { modalDeleteCampaignState } from '../state/modals'
import {
  fetchSourceById,
  getListOfCampaigns,
  getUserChannels,
  fetchCampaignDataById,
  updateStatus,
  getEmailCampaignById,
  getMapiCampaign,
  getMessageSent,
  getUncompleted,
  deleteCampaign
} from '../actions/actions'
import {
  toastShow,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_SUCCESS
} from 'mailup-web-components'

import {
  CAMPAIGN_CHANNEL_EMAIL,
  CAMPAIGN_CHANNEL_MESSENGER,
  CAMPAIGN_CHANNEL_TELEGRAM
} from 'Constants/'

export const resetCampaignListCallback =
  ({ reset }) =>
  async () => {
    reset(pageState)
    reset(resultsState)
    reset(searchState)
    reset(modalDeleteCampaignState)
  }

export const initCampaignListCallback =
  ({ set }) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      loaded: false,
      loading: true
    }))

    try {
      // const accessToken = await getMapiAuth()
      // const accessToken = null
      let userChannels = { Items: [] }
      const mapiChannels = { Items: [] }
      let channels = { Items: [] }
      let allChannelsMapiPermission
      let checkMapiPermissionError

      try {
        userChannels = await getUserChannels()
        allChannelsMapiPermission = userChannels.Items.length === 0
        if (userChannels.Items.length === 0) {
          // ex codice MAPI
          // mapiChannels = await getChannels(accessToken)
          channels = mapiChannels
        } else {
          channels = userChannels.Items
        }
      } catch (error) {
        checkMapiPermissionError = true
      }

      set(configState, (prev) => ({
        ...prev,
        mapiPlatforms: null,
        userChannels,
        mapiChannels,
        channels,
        allChannelsMapiPermission,
        checkMapiPermissionError
      }))
    } catch (error) {
      logAppError({
        Component: 'CampaignList',
        Method: 'initCampaignListCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }
  }

export const getCampaignListCallback =
  ({ set, snapshot, reset }) =>
  async ({ pageNumber, pageSize, orderBy, orderDescending, isReset }) => {
    set(resultsState, (prev) => ({
      ...prev,
      loadingTable: true
    }))

    const search = await snapshot.getPromise(searchState)
    const { allChannelsMapiPermission, checkMapiPermissionError, channels } =
      await snapshot.getPromise(configState)

    let searchParams

    if (isReset) {
      // await reset(searchState)
      searchParams = {
        pageNumber: 1,
        pageSize: 10,
        status: null,
        orderBy: 'UpdateDate',
        orderDescending: true,
        campaignName: ''
      }
    } else {
      searchParams = {
        ...search,
        pageNumber: pageNumber || search.pageNumber,
        pageSize: pageSize || search.pageSize,
        orderDescending:
          orderDescending !== undefined
            ? orderDescending
            : search.orderDescending,
        orderBy: orderBy || search.orderBy
      }
    }
    set(searchState, searchParams)
    try {
      const listOfCampaigns = await getListOfCampaigns(searchParams)

      const campaignDataById = await Promise.all(
        listOfCampaigns.Items.map((e) => fetchCampaignDataById(e.Campaign))
      )

      campaignDataById.forEach((item) => {
        const campaign = listOfCampaigns.Items.find(
          (r) => r.Campaign.Id === item.idCampaign
        ).Campaign
        campaign.IdNl = item.idMessage
        // default
        campaign.ChannelMapiDisable = false
        campaign.ActionMenuDisable = false
        campaign.ChannelDeleted = false
        campaign.ShowManageCmp = false
        campaign.ShowEditCmp = false
        campaign.ShowSentTestMsgCmp = false
        campaign.ShowStats = false
        campaign.ShowSentHistory = false

        // solo email
        if (campaign.Type === CAMPAIGN_CHANNEL_EMAIL && campaign.Status === 1) {
          const showSentFun = async (campaign) => {
            const showSentH = await getMessageSent(campaign.IdNl)
            campaign = {
              ...campaign,
              ShowSentHistory: showSentH.Counters.TotalCounters.EI > 0
            }
          }
          showSentFun(campaign)
        }

        if (item.mapiResponse.length > 0) {
          const found = channels.find(
            (o) =>
              o.Idchannel === item.mapiResponse[0].response.MapiOptions.Channel
          )

          if (!found || checkMapiPermissionError) {
            if (!allChannelsMapiPermission) {
              campaign.ChannelMapiDisable = true
              campaign.ActionMenuDisable = true
            } else {
              campaign.ChannelMapiDisable = true
              campaign.ActionMenuDisable = false
              campaign.ChannelDeleted = true
              campaign.ShowManageCmp = false
              campaign.ShowEditCmp = false
              campaign.ShowSentTestMsgCmp = false
              campaign.ShowStats = false
              // $scope.datatableConfig.actions = actionsConfig
            }
          } else {
            campaign.ChannelMapiDisable = false
            campaign.ActionMenuDisable = false
          }

          // stat
          campaign.ShowStats =
            item.mapiResponse[1].response &&
            item.mapiResponse[1].response.TotalItems > 0

          campaign.NumberOfMapiCampaignSent = item.mapiResponse[1].response
            ? item.mapiResponse[1].response.TotalItems
            : 0
        }
      })

      set(resultsState, (prev) => ({
        ...prev,
        items: listOfCampaigns.Items,
        totalItems: listOfCampaigns.TotalItems
      }))
      set(pageState, (prev) => ({
        ...prev,
        isEmptyState:
          listOfCampaigns.TotalItems === 0 && searchParams.campaignName === '',
        isNotResult:
          listOfCampaigns.TotalItems === 0 && searchParams.campaignName !== ''
      }))
    } catch (error) {
      logAppError({
        Component: 'CampaignList',
        Method: 'getCampaignListCallback',
        appError: error
      })
      set(pageState, (prev) => ({
        ...prev,
        error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
        severity: 'danger'
      }))
    }

    set(resultsState, (prev) => ({
      ...prev,
      loadingTable: false
    }))
    set(pageState, (prev) => ({
      ...prev,
      loaded: true,
      loading: false
    }))
  }

export const getCampaignSourceByIdCallback =
  ({ reset }) =>
  async (idSource) => {
    let sourceByID
    try {
      sourceByID = await fetchSourceById(idSource)
    } catch (error) {
      sourceByID = { error: true }
    }

    return sourceByID
  }

export const updateStatusCallback =
  ({ set, snapshot }) =>
  async (idCampaign, enabled, campaignName, type) => {
    set(pageState, (prev) => ({
      ...prev,
      updateStatusInProgress: true,
      updateStatusIdCampaign: idCampaign
    }))
    try {
      let campaign
      if (type === CAMPAIGN_CHANNEL_EMAIL) {
        campaign = await getEmailCampaignById(idCampaign)
      } else if (
        type === CAMPAIGN_CHANNEL_MESSENGER ||
        type === CAMPAIGN_CHANNEL_TELEGRAM
      ) {
        campaign = await getMapiCampaign(idCampaign)
      }

      campaign.Enabled = !enabled
      await updateStatus(idCampaign, campaign, type)
      set(resultsState, (prev) => ({
        ...prev,
        items: prev.items.map((e) => {
          return {
            ...e,
            Campaign: {
              ...e.Campaign,
              Enabled:
                e.Campaign.Id === idCampaign ? !enabled : e.Campaign.Enabled
            }
          }
        })
      }))

      if (!enabled) {
        toastShow(
          getIntl().formatMessage(
            {
              id: 'Load.ContentsCampaignList.ActivateCampaign'
            },
            { X: campaignName }
          ),
          TOAST_VARIANT_SUCCESS
        )
      } else {
        toastShow(
          getIntl().formatMessage(
            {
              id: 'Load.ContentsCampaignList.DisabledCampaign'
            },
            { X: campaignName }
          ),
          TOAST_VARIANT_SUCCESS
        )
      }
    } catch (error) {
      logAppError({
        Component: 'CampaignList',
        Method: 'updateStatusCallback',
        appError: error
      })
      // set(pageState, (prev) => ({
      //   ...prev,
      //   error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      //   severity: 'danger'
      // }))
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'UpdateStatusErrorGeneric'
      )
    }
    set(pageState, (prev) => ({
      ...prev,
      updateStatusInProgress: false,
      updateStatusIdCampaign: 0
    }))
  }

export const deleteCampaignListCallback =
  ({ set }) =>
  async (idCampaign, idMessage) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true
    }))
    set(modalDeleteCampaignState, (prev) => ({
      ...prev,
      show: false
    }))
    let deleted = false
    try {
      if (idMessage > 0) {
        const resp = await getUncompleted(idMessage)
        if (resp.Value === true) {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.ContentsCampaignWizard.DeleteCampaignOnSentError'
            }),
            TOAST_VARIANT_ERROR,
            'DeleteCampaignOnSentError'
          )
        } else {
          // delete
          deleted = await deleteCampaign(idCampaign)
          if (deleted === true) {
            toastShow(
              getIntl().formatMessage({
                id: 'Load.ContentsCampaignList.DeleteSucces'
              }),
              TOAST_VARIANT_SUCCESS,
              'DeleteSucces'
            )
          }
        }
      } else {
        // delete
        deleted = await deleteCampaign(idCampaign)
        if (deleted === true) {
          toastShow(
            getIntl().formatMessage({
              id: 'Load.ContentsCampaignList.DeleteSucces'
            }),
            TOAST_VARIANT_SUCCESS,
            'DeleteSucces'
          )
        }
      }
    } catch (error) {
      logAppError({
        Component: 'CampaignList',
        Method: 'deleteCampaignListCallback',
        appError: error
      })
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'SendTestError'
      )
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false
    }))

    return deleted
  }
